import {
  getNewAddAddress,
  getEditAddress,
  fetchUserAddressUpdate,
  getDelAddress,
  getAddressDetails,
  getUserAddressDetails,
  getUserDelAddress,
  getNewUserAddAddress,
  getAddressList2,
} from '@fetch/address';

const state = {
  addressList: [],
  opertionsAddressId: 0,
  currentAddressItem: null,
  deleteAddressState: false,
  addAddressStatus: false, // 地址是否添加成功
};

const getters = {
  getAddAddressStatus: (state) => state.addAddressStatus,
};

const actions = {
  getAddressList({ commit }, data) {
    getAddressList2(data).then((res) => {
      if (!res) return;
      commit('setAddressList', res);
    });
  },
  async addAddress({ dispatch }, data) {
    await getNewAddAddress(data).then((res) => {
      if (!res) return;
      if (res) {
        dispatch('getAddressDetailById', {
          id: res,
        });
      }
    });
  },
  async editAddress({ dispatch }, data) {
    await getEditAddress(data).then((res) => {
      if (!res) return;
      if (res) {
        dispatch('getAddressDetailById', {
          id: res,
        });
      }
    });
  },
  async editNewAddress({ dispatch }, data) {
    await fetchUserAddressUpdate(data).then((res) => {
      console.log('res', res);
      if (!res) return;
      if (res) {
        dispatch('getAddressDetailByAddressId', {
          userAddressId: data.addressId || res.data,
        });
      }
    });
  },
  async addNewAddress({ dispatch }, data) {
    await getNewUserAddAddress(data).then((res) => {
      if (!res&&!res.data) return;
      if (res) {
        dispatch('getAddressDetailByAddressId', {
          id: res.data,
        });
      }
    });
  },
  deleteNewAddress({ commit }, data) {
    getUserDelAddress(data).then(() => {
      commit('setDeleteAddressState');
    });
  },
  getAddressDetailByAddressId({ commit }, data) {
    getUserAddressDetails(data).then((res) => {
      commit('setCurrentAddressItem', res.data);
    });
  },

  deleteAddress({ commit }, data) {
    getDelAddress(data).then(() => {
      commit('setDeleteAddressState');
    });
  },
  getAddressDetailById({ commit }, data) {
    getAddressDetails(data).then((res) => {
      commit('setCurrentAddressItem', res);
    });
  },
};

const mutations = {
  setOpertionAddressId(state, id) {
    state.opertionsAddressId = id;
  },
  setCurrentAddressItem(state, item) {
    state.currentAddressItem = item;
  },
  setDeleteAddressState(state) {
    state.deleteAddressState = true;
  },
  setAddressList(state, res) {
    state.addressList = res;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
